import {roundToFixed} from 'services/util/helperFuncs';
import React from "react";
import {TourDurationCell} from "./tourDurationCell";

const Columns = {
  tourId: {
    name: 'tourId',
    header: ({ t }) => t('tourId'),
    body: ({ tour }) => tour.id
  },
  carrier: {
    name: 'carrier',
    header: ({ t }) => t('carrier'),
    body: ({ tour }) => tour.carrierName
  },
  microHub: {
    name: 'microHub',
    header: ({ t }) => t('microHub'),
    body: ({ tour }) => tour.microHubName
  },
  numStops: {
    name: 'numStops',
    header: ({ t }) => t('numStops'),
    body: ({ tour }) => tour.templateStopInstances.length
  },
  distanceCar: {
    name: 'distanceCar',
    header: ({ t }) => t('distanceCar'),
    body: ({ tour }) => roundToFixed(tour.carTravelInformation.distanceInKm, 1)
  },
  durationCar: {
    name: 'durationCar',
    header: ({ t }) => t('durationCar'),
    body: ({ tour, t }) => <TourDurationCell travelDurationInMin={tour.carTravelInformation.travelDurationInMin} tour={tour} t={t}/>
  },
  distanceBicycle: {
    name: 'distanceBicycle',
    header: ({ t }) => t('distanceBicycle'),
    body: ({ tour }) => roundToFixed(tour.bikeTravelInformation.distanceInKm, 1)
  },
  durationBicycle: {
    name: 'durationBicycle',
    header: ({ t }) => t('durationBicycle'),
    body: ({ tour, t }) => <TourDurationCell travelDurationInMin={tour.bikeTravelInformation.travelDurationInMin} tour={tour} t={t}/>
  }
}

export default Columns;